export const notes = {
  'notes.category.PRAISE': 'إشادة',
  'notes.category.LEARNING': 'دراسية',
  'notes.category.BEHAVIOUR': 'سلوكية',
  'notes.category.GENERAL': 'عامة',
  'notes.visibility.PARENTS': 'لولي الأمر',
  'notes.visibility.STAFF': 'للموظفين فقط',
  'notes.visibility.PARENTS.hint': 'تصل إلى ولي الأمر في التطبيق مع إشعار.',
  'notes.visibility.STAFF.hint': 'لا يراها إلا الإدارة ومعلّمو الطالب.',
  'notes.tab': 'الملاحظات',
  'notes.add': 'ملاحظة جديدة',
  'notes.new.title': 'ملاحظة عن {name}',
  'notes.new.category': 'النوع',
  'notes.new.subject': 'المادة',
  'notes.new.subjectPlaceholder': 'مثلاً: الرياضيات',
  'notes.new.body': 'الملاحظة',
  'notes.new.bodyHint': 'اكتب بوضوح واحترام؛ يقرؤها ولي الأمر كما هي ولا يمكن تعديلها.',
  'notes.new.visibility': 'لمن',
  'notes.new.send': 'إرسال لولي الأمر',
  'notes.new.save': 'حفظ للموظفين',
  'notes.new.count': '{n} من ١٠٠٠',
  'notes.sent': 'أُرسلت الملاحظة لولي الأمر',
  'notes.saved': 'حُفظت الملاحظة',
  'notes.empty': 'لا ملاحظات بعد',
  'notes.emptyBody': 'ما يكتبه المعلّمون والإدارة عن الطالب يظهر هنا.',
  'notes.readBy': 'اطّلع عليها: {names}',
  'notes.unread': 'لم يطّلع عليها ولي الأمر بعد',
  'notes.hiddenLabel': 'مخفية',
  'notes.hiddenBy': 'أخفاها {name}',
  'notes.hiddenReason': 'السبب: {reason}',
  'notes.hide': 'إخفاء',
  'notes.hide.title': 'إخفاء هذه الملاحظة؟',
  'notes.hide.body': 'لن يراها ولي الأمر ولا المعلّمون بعد الآن، وتبقى محفوظة في السجل مع السبب.',
  'notes.hide.reason': 'السبب',
  'notes.hide.placeholder': 'مثلاً: كُتبت للطالب الخطأ',
  'notes.hide.done': 'أُخفيت الملاحظة',
  'notes.page.title': 'ملاحظات المعلّمين',
  'notes.page.subtitle': 'كل ما كتبه المعلّمون والإدارة عن الطلاب، الأحدث أولاً',
  'notes.filter.class': 'الصف',
  'notes.filter.allClasses': 'كل الصفوف',
  'notes.filter.all': 'الكل',
  'notes.end': 'لا ملاحظات أقدم',
} as const;
